export const throttled = (callback, time) => {
    let lastRun = 0;
    return (...args) => {
        const now = Date.now();
        if (now - lastRun >= time) {
            lastRun = now;
            callback(...args);
        }
    };
};
//# sourceMappingURL=throttled.js.map